import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as memberpaymentSlice from "../features/member-payments/member-payment.slice";
import Loader from "../components/loader";
import { getDefaultMemberPaymentSearchCriteria } from "../service/model/member-payment.model";
import { useEffect, useState } from "react";
import { subDays } from "date-fns";
import StyledPagination from "../components/table/styled-pagination";
import { configs } from "../app/app-configs";
import PaymentHistory from "../features/member-payments/components/payment-history";

const MemberPaymentsMemberView = () => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(memberpaymentSlice.selectIsLoading);
    const memberpayments = useAppSelector(memberpaymentSlice.selectMemberPayments);
    const totalPages = useAppSelector(memberpaymentSlice.selectTotalPages);
    const [page, setPage] = useState(1);

    const getMemberPayments = async () => {
        await dispatch(memberpaymentSlice.fetchMemberPaymentsPage(
            {
                ...getDefaultMemberPaymentSearchCriteria(),
                from: subDays(new Date(), 365).toISOString().slice(0, 10),
            }
        ));
    }

    useEffect(() => {
        getMemberPayments();
    }, []);

    useEffect(() => {
        dispatch(memberpaymentSlice.fetchMemberPaymentsPage(
            {
                ...getDefaultMemberPaymentSearchCriteria(),
                pagination: {
                    page: page - 1,
                    size: configs.PAGE_SIZE
                },
                from: subDays(new Date(), 365).toISOString().slice(0, 10)
            }
        ))
    }, [page]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {memberpayments &&
                <>
                    <PaymentHistory payments={memberpayments ?? []} />
                    <StyledPagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={(page) => {
                            handlePageChange(page);
                        }}
                    />
                </>
            }
        </div>
    )
}

export default MemberPaymentsMemberView;